import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Container,
  Grid,
  LinearProgress,
  Typography,
  Button,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useData from "../../../Hooks/useData";
import { serviceIcons } from "../../../constants/serviceIcons";

const Whyus = () => {
  const [ourServices, setOurServices] = useState([]);
  const services = useData();

  useEffect(() => {
    if (services.length > 0) {
      setOurServices(services.slice(1, 4));
    }
  }, [services]);

  return (
    <Box
      sx={{
        bgcolor: "#fff",
        color: "primary.main",
        py: 6,
        textAlign: "center",
      }}
    >
      <Container maxWidth="xl">
        {/* ---------- HEADER ---------- */}
        <Typography sx={{ mb: 1, fontWeight: 700 }} variant="h6">
          Why Choose Us
        </Typography>

        <Typography sx={{ mb: 6 }} variant="h5">
          More Than Just Claw Machines
        </Typography>

        {/* ---------- GRID ---------- */}
        {services.length === 0 && <LinearProgress color="secondary" />}

        {services.length > 0 && (
          <Grid container spacing={4} justifyContent="center">
            {ourServices.map((service) => {
              const Icon = serviceIcons[service.iconKey];

              return (
                <Grid key={service.id} item xs={12} md={6} lg={4}>
                  <Card
                    sx={{
                      maxWidth: 345,
                      mx: "auto",
                      borderRadius: 3,
                      cursor: "pointer",
                      transition: "all 0.35s ease",
                      "&:hover": {
                        boxShadow: 10,
                        transform: "translateY(-4px)",
                      },
                      "&:hover img": {
                        transform: "scale(1.05)",
                      },
                      "&:hover .service-title": {
                        color: "#0f7ca4",
                      },
                    }}
                  >
                    {/* ENTIRE CARD CLICKABLE */}
                    <CardActionArea
                      component={Link}
                      to={`/explore/${service.slug}`}
                      disableRipple
                      sx={{
                        "& .MuiCardActionArea-focusHighlight": {
                          opacity: 0,
                        },
                      }}
                    >
                      <CardMedia
                        component="img"
                        height="220"
                        image={service.service_img}
                        alt={service.treatment}
                        sx={{
                          transition: "transform 0.35s ease",
                        }}
                      />

                      <CardContent
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 1,
                          py: 3,
                        }}
                      >
                        {/* ICON */}
                        {Icon && (
                          <Icon
                            sx={{
                              fontSize: 44,
                              color: "primary.main",
                              transition: "transform 0.3s ease",
                              ".MuiCard-root:hover &": {
                                transform: "scale(1.15)",
                              },
                            }}
                          />
                        )}

                        {/* TITLE */}
                        <Typography
                          className="service-title"
                          variant="h6"
                          sx={{ fontWeight: 600 }}
                        >
                          {service.treatment}
                        </Typography>

                        {/* AFFORDANCE */}
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            opacity: 0.8,
                            transition: "opacity 0.3s ease",
                            ".MuiCard-root:hover &": {
                              opacity: 1,
                            },
                          }}
                        >
                          Learn more →
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        )}

        {/* ---------- CTA ---------- */}
        <Box sx={{ mt: 6 }}>
          <Button
            component={Link}
            to="/services#services"
            variant="contained"
            size="large"
            sx={{
              borderRadius: 999,
              px: 5,
              py: 1.5,
              fontWeight: 600,
              textTransform: "none",
              boxShadow: 6,
            }}
          >
            Explore →
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Whyus;
